import axios from 'axios';
import { BluViuNutritionSite } from '../types/bluviu-nutrition-site.type';

/**
 * Returns a list of sites within the company with the specified globalCompanyId, to which the currently logged in user has access. For each site we also include the number of calibrations and scenarios it has.
 * @param globalCompanyId
 * @returns
 */
export const getBluViuNutritionSites = async (globalCompanyId: string): Promise<BluViuNutritionSite[]> => {
  const res = await axios.get<BluViuNutritionSite[]>(`/ewosapi/v1/scenario/sites?globalCompanyId=${globalCompanyId}`);

  return res.data;
};
